import React, { Component } from 'react';
import { Flex, Box , Text} from 'rebass';
import { Link } from "gatsby"
import Modal from 'react-modal';
import Question from './svgs/question';
import Times from './svgs/times';

Modal.setAppElement(`#___gatsby`);

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.58)"
  },
  content: {
    position: "relative",
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto",
    maxWidth: "70vw",
    margin: "50px auto",
    padding: 0,
    border: 0,
    backgroundColor: '#96A0AA'
  }
};

class Entry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hintOpen: false,
    }
    this.handleHintOpen = this.handleHintOpen.bind(this);
    this.handleHintClose = this.handleHintClose.bind(this);
  }
  handleHintOpen() {
    this.setState({ hintOpen: true })
  }
  handleHintClose() {
    this.setState({ hintOpen: false })
  }
  render() {
    const { title, hints, assignment, flag, extra } = this.props;
    return (
      <Flex
        flexDirection='column'
        borderRadius='10'
        px={[2, 4]}
        py={[2, 4]}
        mb={[3, 5]}
        color='#2e3440'
        bg='#96A0AA'
        fontWeight="450"
      >
        <h2 align='center'>{title}</h2>
        { extra ? extra : null }
        {
          assignment ? (
            <Text p={[2, 3]} mt={extra ? 2 : 0} lineHeight='1.7rem' color='#80aebe' bg='#2e3440' mb={3} > {assignment} </Text>
          ) : null
        }
        { hints.length ? (
          <Flex height='6vh' flexDirection='row' mb={2} alignItems='center'>
            <Flex mr={2} style={{ cursor: 'pointer'}} onClick={this.handleHintOpen} justifyContent='center' alignItems='center'>
              <Question height='100%' />
              <Text fontWeight='600' ml={2}> Hints</Text>
            </Flex>
            <Text align='center' color='gray'>click to expand</Text>
          </Flex>
        ) : null
        }
        {
          hints.length && this.state.hintOpen ? (
            <Modal
              isOpen={this.state.hintOpen}
              onRequestClose={this.handleHintClose}
              style={modalStyles}
            >
              <Flex
                color='#2e3440'
                fontFamily='Roboto'
                flexDirection='row'
                justifyContent='flex-end'
                alignItems='center'
                pr={3}
                pt={2}
              >
                <Text fontSize={[4, 5]} fontWeight='450' pl={3}>Hints:</Text>
                <Box m='auto'></Box>
                <Link
                  to="/"
                  aria-label="close modal"
                  sx={{
                    width: "40px",
                    height: "40px",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    m: 3,
                    right: 0,
                    top: 0,
                    zIndex: 1,
                    color: "green",
                    borderRadius: "50%",
                    ":hover": {
                      color: "white",
                      bg: "#fbf9f926"
                    }
                  }}
                  onClick={e => {
                    e.preventDefault();
                    this.handleHintClose();
                  }}
                >
                  <Times />
                </Link>
              </Flex>
              <Flex px={[2,3]} pb={3} flexDirection='column'>
               {hints.map((h,i) => <Box fontFamily='Roboto' lineHeight='1rem' fontSize={['12px', '14px']} wordWrap='break-word' overflowWrap='break-word' key={i}>{h}</Box>)}
              </Flex>
            </Modal>
          ) : null
        }

        {this.props.children}

        {
          flag && (
            <Text mt={3} color='black' p={1}><b style={{backgroundColor:'#13914B'}}>FLAG:</b><span>{`  `}</span>{flag}</Text>
          )
        }
      </Flex>
    );
  }

}

export default Entry;
